"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "desio": {
    "927bb041": [{
      "hkey": "db8b9309",
      "slug": "san-giorgio-san-giuseppe",
      "name": "San Giorgio-San Giuseppe",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "db8b9309",
      "slug": "san-giorgio-san-giuseppe",
      "name": "San Giorgio-San Giuseppe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d78aeff": [{
      "hkey": "db8b9309",
      "slug": "san-giorgio-san-giuseppe",
      "name": "San Giorgio-San Giuseppe",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe": [{
      "hkey": "db8b9309",
      "slug": "san-giorgio-san-giuseppe",
      "name": "San Giorgio-San Giuseppe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "desio"
    }],
    "cb99d99e": [{
      "hkey": "754f718b",
      "slug": "san-vincenzo-piscina",
      "name": "San Vincenzo-Piscina",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "754f718b",
      "slug": "san-vincenzo-piscina",
      "name": "San Vincenzo-Piscina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;